module.exports = __webpack_public_path__ + "img/diagnosis-2.3a6dcdc2.png";